var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"header"},[_c('span',{staticClass:"md-title"},[_vm._v("Call Logs")])])}]

export { render, staticRenderFns }